// This file is autogenerated. Any changes will be overwritten.

export const set = 'streamline';

export const name = 'dataviz-donut';

export const Component = () => (
  <g fill='none' stroke='currentColor' strokeLinecap='round' strokeLinejoin='round'>
    <path d='M9 17.424A8.424 8.424 0 1 0 9 .576a8.424 8.424 0 0 0 0 16.848z' />
    <path d='M9 11.592a2.592 2.592 0 1 0 0-5.184 2.592 2.592 0 0 0 0 5.184zM9 .576v5.832M17.424 9h-5.832m-8.568 5.976 4.104-4.104' />
  </g>
);

export const viewBox = '0 0 18 18';
